import React, { useState } from 'react';
import useUsers from '../hooks/useUsers';
import ManageUsersTable from './ManageUsersTable';
import UserDetailModal from './UserDetailModal'
import { useAuth } from '../../../contexts/AuthContext';

const UsersPage: React.FC = () => {
  const { user } = useAuth();
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  // Get users data from our custom hook
  const { 
    users, 
    allUsers,
    isLoading, 
    error, 
    refresh
  } = useUsers(user?.token || null);

  // Handle view details click
  const handleViewDetails = (userId: string) => {
    setSelectedUserId(userId);
  };

  const handleCloseModal = () => {
    setSelectedUserId(null);
  };

  return (
    <div className="users-container">
      <div className="users-content">
        <h2>User Management</h2>

        <ManageUsersTable
          users={users}
          allUsers={allUsers}
          isLoading={isLoading}
          error={error}
          refresh={refresh}
          onViewDetails={handleViewDetails}
        />
      </div>

      <UserDetailModal
        open={selectedUserId !== null}
        onClose={handleCloseModal}
        userId={selectedUserId}
      />
    </div>
  );
};

export default UsersPage;
